const AdminHome = () => {
  return (
    <>
      <h1>Admin Dashboard</h1>
      <p>Welcome to Robotec administration panel.</p>
    </>
  );
};

export default AdminHome;
